import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface SupplierPaymentParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface SupplierPayment {
    paymentId: any;
    supplierId: any;
    gRNId: string;
    paymentAmount:number;
    tenantId:any;
    branchId:any;
    
    parameters?: SupplierPaymentParameter[];
    links?: any;
}


export abstract class SupplierPaymentData {
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<SupplierPayment[]>;
    abstract create(url: string, data: SupplierPayment[]): Observable<SupplierPayment[]>;
    abstract update(url: string, data: SupplierPayment): Observable<SupplierPayment>;
    abstract delete(url: string): Observable<any>;
   abstract getById(url:string):Observable<any>;
   abstract updateSupPaymentDet(url: string, data: SupplierPayment[]):Observable<any>;
}
